import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError } from "@nju/result";
import { IRetryPaymentResult } from "./types";
import { serverResponse } from "./validators";

interface IParams {
  payerId: string;
}

export async function retryPayment({
  payerId,
}: IParams): Promise<IRetryPaymentResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/payment/retry`,
    {
      method: "put",
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
      searchParams: {
        payerId,
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
